import useConceptConfiguration from '../ConceptCalculation/useConceptConfiguration'
import General from './General'
import AreaOverview from './AreaOverview'
import Modules from './Modules'
import FloorAnalysis from './FloorAnalysis/FloorAnalysis'
import Diagrams from './Diagrams/Diagrams'

const Summary: React.FC<{}> = () => {
  const { getActiveConcept, conceptDataCluster } = useConceptConfiguration()

  if (!getActiveConcept() && !!conceptDataCluster) return null
  const concept = getActiveConcept()

  return (
    <div className="flex flex-col gap-3">
      <Diagrams concept={concept} />
      <General concept={concept} conceptDataCluster={conceptDataCluster} />
      <FloorAnalysis concept={concept} />
      <AreaOverview concept={concept} />
      <Modules concept={concept} />
    </div>
  )
}

export default Summary
